import { Col, Tabs, } from "antd";

import React, { ReactElement, useState, } from "react";
import { } from "antd";
import { useDispatch } from "react-redux";
import { TabBar } from "../../compnents/widgets/TabBar";
import { Formula } from "./formula/formulas/formula";
import { NoFormula } from "./formula/noformula/noformula";
import styles from "./nurse.module.css";
import { UnexecutedPrescription } from "./formula/unexecutedPrescription/unexecutedPrescription";
import { ExecutedPrescription } from "./formula/executedPrescriptions/executedPrescriptions";

const { TabPane } = Tabs;
export const Nurse = (): ReactElement => {
  const dispatch = useDispatch();
  const [selectTabKey, setSelectTabKey] = useState("0");
  return (
    <>
      <Col className={styles.container}>
        <TabBar style={{ marginBottom: "20px" }} onChange={(e) => {
          setSelectTabKey(e)
        }}>
          <TabPane key="0" tab="未执行处方">
            {/* < NoFormula/> */}
            <UnexecutedPrescription selectTabKey={selectTabKey} />
          </TabPane>
          <TabPane key="1" tab="已执行处方">
            {/* <Formula /> */}
            <ExecutedPrescription selectTabKey={selectTabKey} />
          </TabPane>
        </TabBar>
      </Col>
    </>
  );
};


